import { render, staticRenderFns } from "./ListadoSolicitudTransferencias.vue?vue&type=template&id=66d5c4ad"
import script from "./ListadoSolicitudTransferencias.vue?vue&type=script&lang=js"
export * from "./ListadoSolicitudTransferencias.vue?vue&type=script&lang=js"
import style0 from "./ListadoSolicitudTransferencias.vue?vue&type=style&index=0&id=66d5c4ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports